module.exports = __webpack_public_path__ + "static/images/step4.174f621.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/step/step4.png
// module id = bLbf
// module chunks = 1